import { getEnvVars } from "selectors/envVars";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import Urls from "utils/Urls";

const useEnvVars = () => {
  const history = useHistory();

  const envVars = useSelector(getEnvVars);

  const setEnvVars = useCallback((newValues, state, replace = false) => {
    const prevEnvVars = Urls.parseQueryString(window.location.search);

    if (replace) {
      history.replace(`?${Urls.objectToQueryString({ ...prevEnvVars, ...newValues })}`, state);
    } else {
      history.push(`?${Urls.objectToQueryString({ ...prevEnvVars, ...newValues })}`, state);
    }
  }, [history]);

  return [envVars, setEnvVars];
};

export default useEnvVars;
